<div class="cancel">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.Term, langText.AreYouSure)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body pt-0">
    <p class="mb-4">{{localize(langSection.CancelModal, langText.Description)}}</p>
    <p><strong>{{localize(langSection.CancelModal, langText.RequestType)}}:</strong>
      {{localizeValue(langSection.RequestType, request.requestType)}}</p>
    @if (request.requestCategory !== 'Planned') {
<p><strong>{{localize(langSection.Term, langText.Date)}}:</strong>
      {{request.earliestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localize(langSection.TimeZones, request.timezoneName)}} - {{request.latestPickupDateTime | localizedDate:"MM/DD
      h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}} {{localize(langSection.TimeZones, request.timezoneName)}}</p>
}
    @if (request.requestCategory === 'Planned') {
<p><strong>{{localize(langSection.Term, langText.Date)}}:</strong>
      {{request.earliestPickupDateTime | localizedDate:"MM/DD h:mm A":"yyyy/MM/DD HH:mm":request.timezoneOffset}}
      {{localize(langSection.TimeZones, request.timezoneName)}}</p>
}

    <p class="mb-2"><strong>{{localize(langSection.Term, langText.Reason)}} *</strong></p>
    <ups-select [value]="cancelReason" [list]="cancelReasons"
      (change)="onReasonChanged($event.target.value)"></ups-select>
    @if (displayCancelReasonOther) {
<div style="margin-top:1rem">
      <p><strong>{{localize(langSection.CancelModal, langText.OtherReason)}} *</strong> <span
          style="float:right">{{cancelReasonOtherText.length}}/256</span></p>
      <textarea placeholder={{placeholder}} [ngClass]="{'t-error': error.length>0}" [(ngModel)]="cancelReasonOtherText"
        maxlength="256"></textarea>
    </div>
}
    <p class="error">{{error}}</p>
  </div>
  <div class="modal-footer">
    <div class="buttons">
      <button type="button" class="btn btn-green" (click)="cancelRequest()">{{localize(langSection.Term, langText.Yes)}}</button>
      <button type="button" class="btn btn-white" (click)="dismissModal()">{{localize(langSection.Term,  langText.No)}}</button>
    </div>
    @if (cancelRequestError) {
<div class="text-danger">{{localize(langSection.CancelModal, langText.FailedToSaveChanges)}}</div>
}
  </div>
</div>